<template>
  <div class="w-full mt-4">
    <vs-table
      stripe :data="accountTransaction" pagination :maxItems="10"
      class="w-full" @selected="setSelected"
      :noDataText="$t('message.billsAmount.noTransaction')">
      <template slot="header">
        <h3 class="mb-4">
          {{ accountNumber }}
        </h3>
      </template>
      <template slot="thead">
        <vs-th class="hidden sm:block lg:block xl:block w-1/6">
          {{ $t('message.billsAmount.date_trans') }}
        </vs-th>
        <vs-th class="w-1/2">
          <div class="sm:hidden1 lg:hidden1 xl:hidden1">{{ $t('message.billsAmount.note') }}</div>
          <div> / {{ $t('message.billsAmount.partner') }}</div>
        </vs-th>
        <vs-th class="w-1/4">
          {{ $t('message.billsAmount.amount') }}
        </vs-th>
        <vs-th class="hidden sm:block1 lg:block1 xl:block1 w-1/6">
          {{ $t('message.billsAmount.note') }}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <template v-for="(tr, key) in data">
          <vs-tr :key="key" :data="tr">
            <vs-td :data="tr.date_trans" class="hidden sm:block lg:block xl:block w-1/6">
              {{tr.date_trans}}
            </vs-td>
            <vs-td class="w-1/2">
              <div class="sm:hidden1 lg:hidden1 xl:hidden1">{{tr.note}}</div>
              <div class="font-bold text-primary" v-html="tr.partner_name !== null ? tr.partner_name : $t('message.billsAmount.nullField')"></div>
              <small>
                <div class="text-gray" v-html="tr.partner_account_number !== null ? tr.partner_account_number : $t('message.billsAmount.nullField')"></div>
              </small>
            </vs-td>
            <vs-td class="w-1/6">
              {{tr.type===1?'-':''}}{{tr.amount}}
            </vs-td>
            <vs-td :data="tr.note" class="hidden sm:block1 lg:block1 xl:block1">
              {{tr.note}}
            </vs-td>
          </vs-tr>
          <template v-if="tr.id === selected.id && transactionDetail">
            <vs-tr :key="key+'expd'">
              <vs-td colspan="4">
                <div class="flex w-full flex-wrap">
                  <div class="w-1/2">
                    <div class="font-bold text-primary">{{ $t('message.billsAmount.payer') }}</div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerName') }}:
                        </span>
                      <span>{{transactionDetail.payer.name}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerTin') }}:
                        </span>
                      <span>{{transactionDetail.payer.tin}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerAccount') }}:
                        </span>
                      <span>{{transactionDetail.payer.account_number}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerBankAccount') }}:
                        </span>
                      <span>{{transactionDetail.payer.bank_account}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerBankName') }}:
                        </span>
                      <span>{{transactionDetail.payer.bank_name}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.payerBankBik') }}:
                        </span>
                      <span>{{transactionDetail.payer.bank_bic}}</span>
                    </div>
                  </div>
                  <div class="w-1/2">
                    <div class="font-bold text-primary">{{ $t('message.billsAmount.receiver') }}</div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverName') }}:
                        </span>
                      <span>{{transactionDetail.receiver.name}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverTin') }}:
                        </span>
                      <span>{{transactionDetail.receiver.tin}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverAccount') }}:
                        </span>
                      <span>{{transactionDetail.receiver.account_number}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverBankAccount') }}:
                        </span>
                      <span>{{transactionDetail.receiver.bank_account}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverBankName') }}:
                        </span>
                      <span>{{transactionDetail.receiver.bank_name}}</span>
                    </div>
                    <div>
                        <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                          {{ $t('message.billsAmount.receiverBankBik') }}:
                        </span>
                      <span>{{transactionDetail.receiver.bank_bic}}</span>
                    </div>
                  </div>
                  <div class="w-full mt-6 flex flex-wrap">
                    <div class="w-1/2">
                      <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                        {{ $t('message.accountMovement.note') }}:
                      </span>
                      <span>{{transactionDetail.note}}</span>
                    </div>
                    <div class="w-1/2" v-if="transactionDetail.kind">
                      <span class="font-bold block text-primary  sm:inline md:inline lg:inline xl:inline">
                        {{ $t('message.billsAmount.tableKind') }}:
                      </span>
                      <span>{{ $t('message.billsAmount.tableKind-'+transactionDetail.kind) }}</span>
                    </div>
                    <div class="w-full" v-if="[0,1].indexOf(transactionDetail.kind) !== -1">
                      <vs-button @click="getTransferDetail(transactionDetail.id)"
                                 class="text-right hidden sm:block lg:block xl:block"
                                 color="primary" type="flat" >
                        {{ $t('message.accountMovement.reportButton') }}
                      </vs-button>
                    </div>
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BillsTransactionTable',
  data: () => ({
    selected: {
      id: null
    }
  }),
  methods: {
    ...mapActions('utils', ['clearAccountTransaction', 'fetchAccountTransactionDetail']),
    setSelected (event) {
      if (!event) return false
      this.fetchAccountTransactionDetail({
        transId: event.id,
        accountNumber: this.accountNumber
      })
      if (this.selected.id !== event.id) this.selected = event
      else this.selected = {}
    },
    getTransferDetail (id) {
      this.$emit('get-transfer-report', id)
    }
  },
  computed: {
    ...mapGetters('utils', ['accountTransaction', 'accountNumber', 'accountId', 'transactionDetail'])
  },
  beforeDestroy () {
    this.clearAccountTransaction()
  }
}
</script>

<style scoped>

</style>
